<div class="message">
  <h3>{{ 'OTP.ENTER_YOUR_VERIFICATION_CODE' | translate }}</h3>
</div>
<form [formGroup]="verificationForm">
  <div class="code-area">
    <mat-form-field class="verify-input-field" appearance="outline">
      <input
        matInput
        type="text"
        id="code1"
        (keyup)="nextStep($event, 1)"
        (focus)="focused(1)"
        formControlName="code1"
        maxlength="1"
        (paste)="paste($event)" />
    </mat-form-field>

    <mat-form-field class="verify-input-field" appearance="outline">
      <input
        matInput
        type="text"
        id="code2"
        (keyup)="nextStep($event, 2)"
        (focus)="focused(2)"
        formControlName="code2"
        maxlength="1" />
    </mat-form-field>

    <mat-form-field class="verify-input-field" appearance="outline">
      <input
        matInput
        type="text"
        id="code3"
        (keyup)="nextStep($event, 3)"
        (focus)="focused(3)"
        formControlName="code3"
        maxlength="1" />
    </mat-form-field>

    <mat-form-field class="verify-input-field" appearance="outline">
      <input
        matInput
        type="text"
        id="code4"
        (keyup)="nextStep($event, 4)"
        (focus)="focused(4)"
        formControlName="code4"
        maxlength="1" />
    </mat-form-field>
  </div>

  <!--****** verification-timing-area *******-->
  @if (countDown > 0) {
    <div class="verification-timing-area">
      <h3>
        <span><i class="fa fa-clock"></i></span>{{ countDown | numMinDigit }}
        {{ 'OTP.SECONDS' | translate }}
      </h3>
    </div>
  } @else {
    <div class="action">
      <p>
        {{ 'OTP.NO_OTP' | translate }}?
        <span
          (click)="resendLoginCode()"
          style="text-decoration: underline; text-transform: capitalize">
          {{ 'OTP.RESEND_OTP' | translate }}</span
        >
      </p>
    </div>
  }
</form>
